import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { UserIdentity } from '@venecia/apis/auth';

import { Spinner } from '../spinner/spinner';

@Component({
  selector: 'app-user-profile-modal',
  standalone: true,
  imports: [CommonModule, Spinner, TranslateModule],
  templateUrl: './user-profile-modal.html',
  styleUrl: './user-profile-modal.scss',
})
export class UserProfileModal {
  readonly open = input(false);
  readonly loading = input(false);
  readonly profile = input<UserIdentity | null>(null);

  readonly closed = output<void>();

  readonly profileApplications = computed(() => {
    const profile = this.profile();
    if (!profile) {
      return [];
    }

    return profile.applications.map((application) => ({
      application,
      profileName: profile.profiles.find((item) => item.application?.id === application.id)?.name ?? null,
    }));
  });

  close(): void {
    this.closed.emit();
  }
}
